import api from './client'
import { invalidateCache } from '../../utils/cache'

export const getOperations = (params = {}, forceRefresh = false, requestConfig = {}) => {
  const queryParams = new URLSearchParams()
  if (params.mois) queryParams.append('mois', params.mois)
  if (params.annee) queryParams.append('annee', params.annee)
  return api
    .get(`/operations?${queryParams}`, { useCache: !forceRefresh, ...requestConfig })
    .then((res) => res.data)
}

const onOperationsChange = () => {
  invalidateCache('/stats')
  invalidateCache('/operations')
  invalidateCache('/graphiques')
  window.dispatchEvent(new CustomEvent('operationsChanged'))
}

const throwOnError = (error) => {
  if (error.response) {
    const err = new Error(
      error.response.data?.message ||
        error.response.data?.error ||
        `Erreur ${error.response.status}: ${error.response.statusText}`
    )
    // Conserver la réponse : le modal affiche les erreurs champ par champ.
    err.response = error.response
    err.status = error.response.status
    throw err
  }
  if (error.request) {
    throw new Error('Impossible de contacter le serveur. Vérifiez que le backend est lancé.')
  }
  throw new Error(error.message || 'Une erreur est survenue')
}

export const addOperation = async (data) => {
  try {
    const response = await api.post('/operations', data)
    onOperationsChange()
    return response.data
  } catch (error) {
    throwOnError(error)
  }
}

export const updateOperation = async (id, data) => {
  try {
    const response = await api.put(`/operations/${id}`, data)
    onOperationsChange()
    return response.data
  } catch (error) {
    throwOnError(error)
  }
}

export const deleteOperation = async (id) => {
  try {
    const response = await api.delete(`/operations/${id}`)
    onOperationsChange()
    return response.data
  } catch (error) {
    throwOnError(error)
  }
}
